import * as React from "react";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";

import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

import { RootState } from "../../../../store";
import DoctorAvailabilityChart from "../../../../containers/DashboardV2/ServiceProviderAvailabilityChart/Index";

interface PropType {
  open: boolean;
  onClose: () => void;
  onSlotClick: (startTime: string) => void;
  weekDay: number;
}

export default function DoctorAvailabilityDialog({
  open = false,
  onClose,
  onSlotClick,
  weekDay
}: PropType): React.ReactNode {
  const selectedSp = useSelector((state: RootState) => state.clientPortalUserInfo.selectedSp);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{
        "& .MuiDialog-paper": {
          minWidth: 1200
        }
      }}
    >
      <DialogTitle>Book Appointment</DialogTitle>
      <DialogContent dividers>
        <DoctorAvailabilityChart
          weekDay={weekDay}
          onClose={onClose}
          serviceProviders={[selectedSp]}
          onSlotClick={onSlotClick}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
